import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

export default function AgeBarChart({ data }) {
  const chartData = Array.isArray(data) ? data : [];

  return (
    <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm">
      <h3 className="font-semibold text-slate-900">ช่วงอายุผู้เข้าใช้บริการ</h3>
      <p className="mt-1 text-xs text-slate-500">จำนวนผู้เข้าใช้บริการในแต่ละช่วงอายุ</p>

      {/* ⭐ สำคัญ: min-h + min-w-0 อยู่ที่ parent แล้ว */}
      <div className="mt-4 h-64 min-h-[256px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <XAxis dataKey="range" axisLine={false} tickLine={false} tick={{ fill: "#64748b", fontSize: 12 }} />
            <YAxis allowDecimals={false} axisLine={false} tickLine={false} tick={{ fill: "#94a3b8", fontSize: 12 }} />
            <Tooltip />
            <Bar
              dataKey="count"
              fill="#14B8A6"
              radius={[6, 6, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
